module.exports = __webpack_public_path__ + "static/media/duiwu.eb194fd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/duiwu.mp3
// module id = p/Dt
// module chunks = 208